// extracted by mini-css-extract-plugin
module.exports = {"main-component":"featureSafety_main-component__3oD7t"};